;(function (angular, _, numeral) {
  'use strict'

  angular
    .module('kilo.routes.product.list')
    .controller('ProductListController', ProductListController)

  ProductListController.$inject = [
    // Angular
    '$scope', '$state', '$window', 'urls', '$http',

    // Managers
    'ProductManager',

    // Services
    'SnackService', 'FilterSidebarService', 'ColumnService', 'SelectionService', 'PreferencesService', 'DisplayService',
    'FilterService', 'TemplateService',

    // Resolve
    'pagination', 'categories', 'linkedSearch'

  ]

  function ProductListController (
    // Angular
    $scope, $state, $window, urls, $http,

    // Managers
    ProductManager,

    // Services
    SnackService, FilterSidebarService, ColumnService, SelectionService, PreferencesService, DisplayService,
    FilterService, TemplateService,
    // Resolve
    pagination, categories, linkedSearch

  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {

        // Attributes
        pagination: pagination,
        categories: categories,
        ColumnService: ColumnService,
        selection: SelectionService.getSelection(),
        sideBar: FilterSidebarService,

        // Methods
        addCriteria: addCriteria,
        clearSearch: clearSearch,
        deleteProduct: deleteProduct,
        getCategories: getCategories,
        getList: getList,
        go: go,
        groupFind: FilterService.groupFind,
        isVisible: isVisible,
        newTab: newTab,
        searchProductCategory: searchProductCategory,
        searchProductLabel: searchProductLabel,
        searchProductRef: searchProductRef,
        searchTags: searchTags,
        dropColumn: dropColumn,
        isCompanyPrefsValid: isCompanyPrefsValid,
        searchBpus: searchBpus,
        searchTypes: searchTypes,
        sort: sort
      })

      // Colonnes visibles uniquement (dans l'ordre de self.columns), itérées par le template
      // à la place de self.columns + ng-if="isVisible(col.id)" (toutes les colonnes x N lignes à chaque digest).
      // self.columns est réaffecté (init, dropColumn) mais aussi muté en place (splice de dropColumn,
      // ColumnService.loadNewColumns sur le tableau des préférences, ng-model de column-sidebar sur col.visible) :
      // un seul $watchGroup, non profond, sur la référence du tableau + une signature id:visible.
      $scope.$watchGroup([
        () => self.columns,
        () => self.columns && self.columns.map(c => c.id + ':' + !!c.visible).join(',')
      ], updateVisibleColumns)

      init()
    }

    function init () {
      self.sideBar.init()
      self.ColumnService.init()
      PreferencesService.getPrefsFor('general').then(function (prefs) {
        self.prefs = prefs
        self.columns = ColumnService.getColumns('product')
        if (prefs.hasOwnProperty('settings')) {
          if (_.get(prefs.settings.productList, 'pagination')) {
            self.pagination.perPage = _.get(prefs.settings.productList, 'pagination')
          }
          if (_.get(prefs.settings, 'sideBarVisible')) {
            self.sideBar.filterVisible = _.get(prefs.settings, 'sideBarVisible')
          }
        }
        initLinkedSearch()
        self.selection.selectedData = []
        getList()
      })
    }

    function isCompanyPrefsValid () {
      return PreferencesService.isCompanyPrefsValid()
    }

    function initLinkedSearch () {
      if (linkedSearch && !angular.equals({}, linkedSearch)) {
        self.sideBar.filterVisible = true
        self.pagination.search = linkedSearch
      }
    }

    function dropColumn (source, target) {
      var newIndex = _.findIndex(self.columns, { id: target })
      var oldIndex = _.findIndex(self.columns, { id: source })
      self.columns.splice(newIndex, 0, self.columns.splice(oldIndex, 1)[0])
      self.prefs.save().then(function () {
        self.columns = ColumnService.getColumns('product')
      })
    }

    function newTab (id) {
      var url = $state.href('product.show', { id: id })
      $window.open(url, '_blank')
    }

    function getCategories (search) {
      var newCategories = self.categories.slice()
      if (search && newCategories.indexOf(search) === -1) {
        newCategories.unshift(search)
      }
      return newCategories
    }

    function go (product) {
      $state.go('product.show', { id: product })
    }

    function deleteProduct (product) {
      TemplateService.getAllPrefilledTemplates([product._id]).then((templates) => {
        if (templates['invoices'] || templates['quotes']) {
          DisplayService.displayConfirm('Supprimer', 'Attention, ce produit figure dans certain(e)s de vos factures ou devis pré-remplis, si vous le supprimez, il le sera aussi de ces derniers ! <br><br>' +
          'Afin de confirmer la suppression, merci d\'écrire "<strong class="text-danger">SUPPRIMER</strong>" dans le champs ci-dessous', 'SUPPRIMER').then(() => {
            const url = urls.api + '/kilo/products/bulkProductDeletion'
            $http.put(url, { ids: [product._id], templates: templates }).then(() => {
              product.remove().then(function () {
                SnackService.snack({
                  text: 'Produit supprimé !',
                  delay: 5000
                })
                init()
              })
            })
          })
        } else {
          DisplayService.confirmDeletion().then(function () {
            self.product.remove().then(function () {
              SnackService.snack({
                text: 'Produit supprimé !',
                delay: 5000
              })
              init()
            })
          })
        }
      })
    }

    function sort (name) {
      this.reverse = (self.pagination.orderBy === name) ? !this.reverse : false
      self.pagination.orderBy = name
      self.pagination.reverse = this.reverse
      getList()
    }

    function updateVisibleColumns () {
      self.visibleColumns = _.filter(self.columns, 'visible')
    }

    function isVisible (columnId) {
      if (!self.columns) {
        return
      }
      for (var i = 0; i < self.columns.length; i++) {
        if (self.columns[i].id === columnId) {
          return self.columns[i].visible
        }
      }
      return false
    }

    // SEARCH

    function getList () {
      self.pagination.search = FilterService.sanitizeSearchTree(self.pagination.search, true)
      self.pagination.save()
      self.loading = true

      self.pagination.orderBy = self.pagination.orderBy || '-createdAt'

      var hasArchived = self.pagination.search && FilterService.hasArchivedCriteria(self.pagination.search)
      if (!hasArchived) {
        addCriteria('isArchived', { _id: 'archived', value: 'false' })
        return
      }

      var query =
        ProductManager
          .query({ populate: ['tags', 'bpu', 'type'] })
          .fields('reference label tags category price unit VAT bpu type')
          .paginate(self.pagination.toQueryOptions())

      if (self.pagination.search) {
        query.setQuery(FilterService.parseQueryTree(self.pagination.search))
      }
      var promise = ProductManager.post(query)
      promise.then(function (data) {
        self.products = data.data
        self.pagination.totalElements = data.meta.total
        self.pagination.save()
        self.loading = false

        // Reset the pagination if we try to load page without results
        if (data.meta.total > 0 && !self.products.length && self.pagination.currentPage >= 0) {
          pagination.currentPage = 0
          getList(pagination)
        }
      })
    }

    function addCriteria (key, value, negation) {
      if (value !== undefined && value !== null) {
        self.pagination.search = FilterService.addCriteria(self.pagination.search, key, value, negation)
        getList()
      }
    }

    function clearSearch () {
      self.pagination.search = {}
      getList()
    }

    function searchProductRef (search) {
      return FilterService.searchProductRef(search).then(function (refs) {
        self.refs = refs
      })
    }

    function searchProductLabel (search) {
      return FilterService.searchProductLabel(search).then(function (labels) {
        self.labels = labels
      })
    }

    function searchProductCategory (search) {
      return FilterService.searchProductCategories(search).then(function (categories) {
        self.categories = categories
      })
    }

    function searchTags (query) {
      return FilterService.searchTags(query)
    }

    function searchBpus (search) {
      return FilterService.searchBpu(search).then(function (bpus) {
        self.bpus = bpus
      })
    }

    function searchTypes (search) {
      return FilterService.searchTypes(search).then(function (types) {
        self.types = types
      })
    }
  }
})(window.angular, window._, window.numeral)
